module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b642bc962f488f800c054da650a62428.png";